import * as z from "zod";

/** The account's manufacturers, for the catalog's manufacturer picker. */
export const listInternationalCustomsManufacturers = {
  name: "listInternationalCustomsManufacturers" as const,
  input: z.null(),
  output: z.object({
    manufacturers: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        mid: z.string().nullable(),
      }),
    ),
  }),
};
